<template>
  <div>
    <radio-question
      v-if="!driverEntity"
      :question="driverEntityQuestion"
      class="question-box mb-5"
      @selectAnswer="selectEntityLocal"
    />
    <transition-group
      enter-active-class="fadeIn"
      leave-active-class="fadeOutFast"
      mode="out-in"
    >
      <legal-entity-form
        v-if="driverEntity === 'legal' || localDriverEntity === 'legal'"
        :key="'legalEntity'"
        class="question-box mb-5"
        @updateData="updateLegalEntity"
      />

      <physical-entity-form
        v-if="driverEntity === 'physical' || localDriverEntity === 'physical'"
        :key="'physicalEntity'"
        class="question-box mb-5"
        @updateData="updatePhysicalEntity"
      />

      <more-drivers-form
        v-if="driverEntity === 'physical' && driversNumber === 'limited'"
        :key="'moreDrivers'"
        class="question-box mb-5"
        @updateData="updateAdditionalDrivers"
      />

      <div v-if="completedSection" :key="'goNextRow'" class="d-flex justify-center">
        <v-btn
          color="#df0100"
          class="base-button"
          depressed
          tile
          dark
          large
          @click="$emit('nextStep', dataLayerEvent)"
        >
          Inainte
        </v-btn>
      </div>
    </transition-group>
  </div>
</template>

<script>
import PhysicalEntityForm from '@/components/rca/PhysicalEntityForm';
import LegalEntityForm from '@/components/rca/LegalEntityForm';
import MoreDriversForm from '@/components/rca/MoreDriversForm';
import RadioQuestion from '@/components/RadioQuestion';
import { CONSTANTS } from '@/_utils/static-data';

// driver entity: ['physical', 'legal']
// drivers number: ['limited', 'unlimited']
export default {
  name: 'DriverStep',
  components: { RadioQuestion, MoreDriversForm, LegalEntityForm, PhysicalEntityForm },
  props: {
    driverEntity: {
      type: String,
      default: null
    },
    driversNumber: {
      type: String,
      default: 'limited'
    },
    sectionType: {
      type: String,
      default: 'rca'
    }
  },
  data() {
    return {
      legalEntityAnswers: [],
      validLegalEntityData: false,
      physicalEntityAnswers: [],
      validPhysicalEntityData: false,
      additionalDrivers: [],
      validAdditionalDrivers: true,
      localDriverEntity: null
    };
  },
  computed: {
    isGreenCard() {
      return this.sectionType === 'greenCard';
    },
    dataLayerEvent() {
      return this.isGreenCard ? CONSTANTS.greenCardEventDriver : CONSTANTS.rcaEventDriver;
    },
    completedSection() {
      if (!this.driverEntity) {
        return this.localDriverEntity === 'physical' ? this.validPhysicalEntityData : this.validLegalEntityData;
      }
      if (this.driverEntity === 'legal') {
        return this.validLegalEntityData;
      } else if (this.driverEntity === 'physical') {
        if (this.driversNumber === 'limited' && this.additionalDrivers.length > 0) {
          return this.validPhysicalEntityData && this.validAdditionalDrivers;
        } else {
          return this.validPhysicalEntityData;
        }
      }
      return false;
    },
    driverEntityQuestion() {
      return {
        id: 2,
        order: 2,
        text: 'Posesorul autovehicolului este persoana:',
        type: 'radio',
        optionsDirection: 'row',
        parent: null,
        children: [],
        options: [
          {
            id: 1,
            text: 'Fizica',
            value: 0.9
          },
          {
            id: 2,
            text: 'Juridica',
            value: 1.5
          }
        ]
      };
    }
  },
  watch: {
    driverEntity() {
      this.legalEntityAnswers = [];
      this.validLegalEntityData = false;
      this.physicalEntityAnswers = [];
      this.validPhysicalEntityData = false;
      this.additionalDrivers = [];
      this.validAdditionalDrivers = false;
      this.updateDriverInfo();
    }
  },
  methods: {
    updateLegalEntity({ data, isValid }) {
      if (!data) { return; }
      this.legalEntityAnswers = JSON.parse(JSON.stringify(data));
      this.validLegalEntityData = isValid;
      this.updateDriverInfo();
    },
    updatePhysicalEntity({ data, isValid }) {
      if (!data) { return; }
      this.physicalEntityAnswers = JSON.parse(JSON.stringify(data));
      this.validPhysicalEntityData = isValid;
      this.updateDriverInfo();
    },
    updateAdditionalDrivers({ data, isValid }) {
      if (!data || !Array.isArray(data)) { return; }
      this.additionalDrivers = data;
      this.validAdditionalDrivers = isValid;
      this.updateDriverInfo();
    },
    updateDriverInfo() {
      const driverData = {
        isValid: this.completedSection
      };
      const driverEntity = this.driverEntity || this.localDriverEntity;
      if (driverEntity === 'legal') {
        driverData.legalEntity = this.legalEntityAnswers;
      } else if (driverEntity === 'physical') {
        driverData.physicalEntity = this.physicalEntityAnswers;
        if (this.driversNumber === 'limited') {
          driverData.additionalDrivers = this.additionalDrivers;
        }
      }
      setTimeout(() => {
        this.$emit('updateAnswers', JSON.parse(JSON.stringify(driverData)));
      }, 200);
    },
    selectEntityLocal(data) {
      this.validLegalEntityData = false;
      this.validPhysicalEntityData = false;
      this.localDriverEntity = data?.id === 1 ? 'physical' : 'legal';
    }
  }
};
</script>

<style scoped>
.question-box {
  width: 100% !important;
  background-color: #E7EFFD;
  padding: 8px;
  border-radius: 4px 4px 4px 4px;
}
</style>
